import React from "react";
import FeatureIcon from './feature-icon';

export default class Feature3Icon extends React.Component {
    render() {
        const spanStyle = {
            textAlign: 'center',
            display: 'block',
            width: '90px',
            height: '90px',
            margin: '0 auto 10px auto',
            position: 'relative',
            top: '-3em',
            WebkitBorderRadius: '50%',
            MozBorderRadius: '50%',
            msBorderRadius: '50%',
            BorderRadius: '50%'
        };

        const iconStyle = {
            lineHeight: '90px',
            height: '90px',
            fontSize: '40px',
            color: '#fff'
        }

        return (
            <FeatureIcon  iconName={ this.props.iconName } spanStyle={ spanStyle } iconStyle={ iconStyle }/>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/icons/feature3-icon.jsx